import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Checkbox } from "@faire/web--source/slate/Checkbox";
import { getSpacing } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";

import { CSAT_REASONS } from "./csatReasons";

interface IProps {
  checked: string[];
  setChecked: (checked: string[]) => void;
}

export const ReasonsChecklist: React.FC<IProps> = ({ checked, setChecked }) => {
  const { strictLocalize } = useStrictLocalization();

  const toggleReason = (reason: string) => {
    if (checked.includes(reason)) {
      setChecked(checked.filter((reasonInList) => reasonInList !== reason));
    } else {
      setChecked([...checked, reason]);
    }
  };

  return (
    <div>
      {CSAT_REASONS(strictLocalize).map(({ id, label }) => {
        return (
          <Reason key={id}>
            <Checkbox
              label={label}
              checked={checked.includes(id)}
              onChange={() => toggleReason(id)}
            />
          </Reason>
        );
      })}
    </div>
  );
};

const Reason = styled.div`
  margin: ${getSpacing("1x")} 0;

  input {
    opacity: 0;
  }
`;
